export const getSyntheticMetricTableValue = {
  variable: '$request: SyntheticDashboardTableReq!',
  query: `getSyntheticMetricTableValue(request: $request) {
        metricValue {
            id
            name
            value
        }
        total
    }`
};

export const syntheticByDashboard = {
  variable: '$request: SyntheticDashboardRequest!',
  query: `syntheticByDashboard(request: $request) {
        metricValue {
            id
            name
            value
            threshold
            thresholdValue
            displayKey
        }
        total
    }`
};

export const PostKPM = {
  variable: '$condition: KPMSyntheticRequest!',
  query: `
  response:saveOrUpdateKPMMetric(condition: $condition) {
      id: id
      errorReason: errorReason
    }`
};

export const CreateGroupInPulse = {
  variable: '$condition: PulseGroupInfo!',
  query: `
  PulseGroupResponse: createGroupInPulse(condition: $condition) {
    groupId,
    standardResponse {
        status,
        message
        error
    }
  }`
};

export const DeleteGroupInPulse = {
  variable: '$condition: PulseDeleteGroupRequest!',
  query: `
  PulseGroupResponse: deleteGroupInPulse(condition: $condition) {
    groupId,
    standardResponse {
        status,
        message,
        error
    }
  }`
};

export const GetGroupAlerts = {
  variable: '$condition: PulseDeleteGroupRequest!',
  query: `
  PulseGroupResponse: fetchAlertRules(condition: $condition) {
    status
    message 
    alarmRules{
      ruleId
      ruleName
    }
  }`
};

export const DeleteEGKPM = {
  variable: '$condition: KPMSyntheticRequest!',
  query: `
  response: deleteEGKPM(condition: $condition) {
      id: id
      errorReason: errorReason
    }`
};

export const GetPulseListGroupCards = {
  variable: '$condition: GroupCardsRequest!',
  query: `
      GroupCardsResponse: getPulseListGroupCards(condition: $condition) {
        total,
        groupCardsResponse {
          groupId,
          groupCardSummary {
            groupName
            endPointCount
            averageHealth {
              value,
              rating
            }
          }
        }
      }
  `
};

export const getKPMConfig = {
  variable: '$request: KPMConfigRequest!',
  query: `getKPMConfig(request: $request) {
        total
        kpm {
            serviceId
            metricName
            goodThreshold
            metaId
            goodOp
            poorThreshold
            poorOp
            createdBy
            modified
            modifiedBy
            lastUpdate
        }
    }`
};

export const getErrors = {
  variable: ['$condition: BrowserErrorLogQueryCondition'],
  query: `queryBrowserErrorSummary(condition: $condition) {
      total
      errors {
          users
          events
          lastOccurrence
          errorName
          trace
          errorLog {
        message
        
      }
      }
    }`
};

export const getErrorLogs = {
  variable: ['$condition: BrowserErrorLogQueryCondition'],
  query: `queryBrowserErrorLogs(condition: $condition) {
    logs {
      userId
      uniqueId
      os
      device
      browser
      time
      traceId
      apmServiceTrace {
        serviceId
        serviceName
      }
      endPoints {
        key : key
        label :value
      }
      instancePoints {
        key : key
        label : value
      }
    }
    total
  }`
};

export const getErrorLog = {
  variable: ['$eventId: ID!'],
  query: `queryBrowserErrorLog(eventId: $eventId) {
      userId
      uniqueId
      os
      device
      browser
      message
      service
      serviceVersion
      serviceName
      serviceVersionName
      time
      pagePath
      category
      errorUrl
      stack
      grade
      userAgent
      environment
      level
      errorName
      exception {
        type
        value
        module
        threadId
        message
        stacktrace {
          frames {
            filename
            function
            lineno
            colno
          }
        }
      }
      sdk {
        name
        version
      }
      breadcrumbs {
        type
        message
        data {
          key
          value
        }
        timestamp
        level
        category
      }
      traceId
      apmServiceTrace {
        serviceId
        serviceName
      }
      endPoints {
        key : key
        label :value
      }
      instancePoints {
        key : key
        label : value
      }
  }`
};

export const getSMGraphTemplate = {
  variable: '$request: KPMConfigRequest!',
  query: `response:getKPMGraphTemplate(request: $request)`
};

export const getAvailability = {
  variable: '$request: AvailabilityRequest!',
  query: `getAvailability(request: $request) {
        name
        slaPercent
        downTime
        lastHourSla
        lastDaySla
        lastWeekSla
        lastWeekSlaThreshold
        lastDaySlaThreshold
        lastHourSlaThreshold
        slaThreshold
        avgResponseTimeThreshold
        lastHourDownTime
        lastDayDownTime
        lastWeekDownTime
        lastHourUptime
        lastDayUptime
        lastWeekUptime
        avgRespTime
        status
        expectedStatus
        overFailures
    }`
};
export const getSummaryTemplate = {
  variable: '$request: KPMConfigRequest',
  query: `getSummaryTemplate(request: $request) {
    id
    latency
    pingTime
    recordId
    date
    issue
    errorCode
    summary
  }`
};
export const getSummaryInfoTemplate = {
  variable: '$request: KPMConfigRequest',
  query: `getSummaryInfoTemplate(request: $request) {
    id
    request
    destIp
    port
    responseHeaders
    responseBody
    connection
    protocol
    createdAt
  }`
};

export const getAllGroupsListTemplate = {
  variable: '$teamId: String!',
  query: `AllGroups: getAllGroups(teamId: $teamId) {
    id,
    name
  }`
};

export const getEndpointDetails = {
  variable: '$condition: EndpointsTableRequest!',
  query: `getEndpointDetails(condition: $condition) {
    total,
    endpointsList {
    id
    urlAlias
    url
    groupId
    groupName
    groupId
    urlAvailability {
      uptimePercentage {
          value,
          rating
      },
      downtime {
          value,
          rating
      },
      avgResponseTime {
          value,
          rating
      }
    }
    createdOn
    AirflowStatus
    atsaTestCaseStatus
    lastExecutedOn
    atsaTestType
  }
  }`
};

export const addingEndpoint = {
  variable: '$condition: ManualEndpointRequest!',
  query: `addingEndpoint(condition: $condition) {
   status
   errorMsg
   successMsg
   groupId
   message
   endpointId
  }`
};

export const fetchEndpointDetails = {
  variable: '$endpointId: String!',
  query: `PulseInfoResponse: fetchEndpointDetails(endpointId: $endpointId) {
    status
    errorMsg
    successMsg
    groupId
    message
    endpointId
    manualEndpointResponse {
        endpointInfoConfig {
            basicInfoConfig {
                    url
                    endpointType
                    urlAlias
            }
            authConfig {
                    authType
                    tokenId
                    headerPrefix
                    tokenName
            }
            requestConfigResponse {
                checkType
                expectedStatus
                headers 
                    {
                        key
                        value
                    }
                
                postData
            }
            additionalOptions {
                interval
                timeout
                ssl
                permalinkUrl
            }
        }
        kpm {
            availabilityResponse {
                good
                poor
            }
            respTimeResponse {
                good
                poor
            }
        }
    }
  }`
};
export const saveScheduleTest = {
  variable: '$condition: AirflowScheduleDagRequestGQL!',
  query: `
  response: scheduleAirflow(condition: $condition) {
    id
    status
    displayMsg
    message
  }
  `
};

export const pauseResumeAirflow = {
  variable: '$condition: AirflowPauseResume!',
  query: `
    CommonInfoResponse: pauseResumeAirflow(condition: $condition) {
    id,
    status,
    displayMsg,
    message
  }
  `
};

export const fetchAirflowSchedule = {
  variable: '$endpointId: String!',
  query: `response: fetchAirflowSchedule(endpointId: $endpointId) {
      testId
      cronFormat
      isExecuteOnce
    }`
};

export const getRefreshTestStatuses = {
  variable: '$condition: AtssaFetchTestCaseInfoRequestEntity!',
  query: `
  response: fetchTestCaseInfo(condition: $condition) {
      tapStatus
      lastExecutedOn
      atsaTestType
    }
  `
};

export const getTestPlanIdsList = {
  variable: `$condition: AtssaFetchTestCaseInfoRequestEntity!`,
  query: `
  response: fetchTestCaseInfo(condition: $condition) {
    title
    testPlanId
  }
  `
};

export const saveOauth2Token = {
  variable: '$condition: AuthPulseRequestGql!',
  query: `saveAuthToken(condition: $condition) {
   status
   errorMsg
   successMsg
   groupId
   message
   endpointId
  }`
};

export const getOauthToken = {
  variable: `$condition: AuthPulseRequestGql!`,
  query: `response: fetchPulseAuthTokens(condition: $condition) {
    status
    errorMsg
    successMsg
    tokenList {
      tokenId
      tokenName
    }
  }`
};

export const getAllSecretsListTemplate = {
  variable: '$condition: SecretRequestGql!',
  query: `secretsList: getAllSecrets(condition: $condition) {
    secrets {
      secretId
      secretType
      secretKey
      secretValue
      isVisible
      updatedAt,
      createdAt
    }
    total
    errorMsg
  }`
};

export const saveSecretTokenTemplate = {
  variable: '$condition: SecretSaveRequest!',
  query: `pulseInfoResponse: saveSecret(condition: $condition) {
   status
   errorMsg
   successMsg
  }`
};

export const checkSecretTemplate = {
  variable: '$condition: SecretCheckRequestGql!',
  query: `secretresp: isPresent(condition: $condition) {
    secretList {
      secretName,
      secretType,
      isExist
    }
    errorMsg
   }`
}

export const getTokenLinkedToSecretTemplate = {
  variable: `$condition: TokenRequestGql!`,
  query: `tokensList: getListofTokensLinkedtoSecretId(condition: $condition) {
    tokenList {
      tokenId
      tokenName 
      endpointCount
      createdAt
      updatedAt
    }
    total
    errorMsg
  }`
}

export const deleteSecretTemplate = {
  variable: '$condition: DeleteSecretGql!',
  query: `deleteSecretResponse: deleteSecret(condition: $condition) {
   status
   errorMsg
  }`
};

export const getTokenListTemplate = {
  variable: '$condition: TokenEndpointRequestGql!',
  query: `tokenEndpointList: getAllTokens(condition: $condition) {
    tokens {
      tokenId
      tokenName 
      endpointCount
      createdAt
      updatedAt
    }
    total
    errorMsg
  }`
}

export const getATokenTemplate = {
  variable: '$condition: TokenRequestPulseGql!',
  query: `tokenResponse: getAToken(condition: $condition) {
    tokenId
    tokenName 
    accessTokenUrl
    clientId
    clientSecret
    audience
    scope
    resource
    errorMsg
  }`
}

export const deleteTokenTemplate = {
  variable: '$condition: TokenRequestPulseGql!',
  query: `deleteTokenResponse: deleteToken(condition: $condition) {
   status
   errorMsg
  }`
};

export const getEndpointListLinkedToTokenTemplate = {
  variable: '$condition: TokenRequestPulseGql!',
  query: `endpointListResponse: getEndpointsLinkedToAToken(condition: $condition) {
    endpoints {
      id
      name
      domain
    }
    total
    errorMsg
  }`
}

export const editTokenTemplate = {
  variable: '$condition: EditTokenRequestGql!',
  query: `editTokenResponse: editToken(condition: $condition) {
    status
    errorMsg
  }`
}

export const getMappedEndpointDetails = {
  variable: '$condition: EndpointsTableRequest!',
  query: `getEndpointDetails(condition: $condition) {
    total,
    endpointsList {
    id
    urlAlias
    url
    groupId
    groupName
    groupId
    urlAvailability {
      uptimePercentage {
          value,
          rating
      },
      downtime {
          value,
          rating
      },
      avgResponseTime {
          value,
          rating
      }
    }
    createdOn
    AirflowStatus
    atsaTestCaseStatus
    lastExecutedOn
    atsaTestType
  }
  }`
};